// extracted by mini-css-extract-plugin
export default {"slider":"ProductImagesSlider_slider__Ams2N","image":"ProductImagesSlider_image__IwsWK"};